import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const urlSearchHistorySelected = () => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:history:selected`, 
        category: settings.categoryName 
    });
};

export default urlSearchHistorySelected;